var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / symbols / linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33317 2.66675H26.6665C28.1393 2.66675 29.3332 3.86066 29.3332 5.33341V26.6667C29.3332 28.1395 28.1393 29.3334 26.6665 29.3334H5.33317C3.86041 29.3334 2.6665 28.1395 2.6665 26.6667V5.33341C2.6665 3.86066 3.86041 2.66675 5.33317 2.66675ZM5.33301 5.3335V26.6668H26.6663V5.3335H5.33301ZM17.333 12C16.6427 12 15.9133 12.211 15.2692 12.6029L14.6663 12H13.333V21.3333H15.9997V16C15.9997 15.2323 16.7916 14.6667 17.333 14.6667H18.6663C19.2077 14.6667 19.9997 15.2323 19.9997 16V21.3333H22.6663V16C22.6663 13.5296 20.5249 12 18.6663 12H17.333ZM10.6663 10.6667C11.4027 10.6667 11.9997 10.0697 11.9997 9.33333C11.9997 8.59695 11.4027 8 10.6663 8C9.92996 8 9.33301 8.59695 9.33301 9.33333C9.33301 10.0697 9.92996 10.6667 10.6663 10.6667ZM9.33301 12V21.3333H11.9997V12H9.33301Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2d786b1c5884abe804ea127d6426549b.svg";
export { ForwardRef as ReactComponent };